import TildeIcon from "../../../../assets/images/generico/TildeIcon";
import { ModalAutoTsuccessContainer } from "./localStyle";

const ModalAutoTSuccess = ({ descripcion, textBtn, onClick }) => {
  return (
    <ModalAutoTsuccessContainer>
      <div className="backgorund-containerModalAutoT" />
      <div className="cruz-circle">
        <TildeIcon color={"white"} height={"30"} width={"30"} />
      </div>
      <p
        dangerouslySetInnerHTML={{
          __html: descripcion,
        }}
      />
      <button onClick={onClick}>{textBtn}</button>
    </ModalAutoTsuccessContainer>
  );
};

export default ModalAutoTSuccess;
